import { useState } from "react"

import { useTheme } from "@emotion/react"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker"

import { useDateLocale, useTranslation } from "@l2r-front/l2r-i18n"
import { CloseIcon, KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from "@l2r-front/l2r-icons"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./DatePicker.styled"

export const DatePicker = (props) => {

    const {
        disableOpenPicker,
        ...otherProps
    } = props
    const locale = useDateLocale()

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()
    const [open, setOpen] = useState(false)

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
            <Styled.DatePicker
                disableOpenPicker={disableOpenPicker}
                {...otherProps}
                open={disableOpenPicker ? open : undefined}
                onClose={() => setOpen(false)}
                slots={{
                    leftArrowIcon: KeyboardArrowLeftIcon,
                    rightArrowIcon: KeyboardArrowRightIcon,
                    clearIcon: CloseIcon,
                }}
                slotProps={{
                    ...props.slotProps,
                    desktopPaper: {
                        ...props.slotProps?.desktopPaper,
                        elevation: 3,
                        sx: {
                            borderRadius: theme.spacing(3),
                            marginTop: theme.spacing(1),
                        },
                    },
                    mobilePaper: {
                        ...props.slotProps?.mobilePaper,
                        elevation: 3,
                        sx: {
                            borderRadius: theme.spacing(3),
                            marginTop: theme.spacing(1),
                        },
                    },
                    paper: {
                        ...props.slotProps?.paper,
                        elevation: 2,
                        sx: {
                            borderRadius: theme.spacing(3),
                            marginTop: theme.spacing(1),
                        },
                    },
                    textField: {
                        ...props.slotProps?.textField,
                        onClick: () => setOpen(!open),
                        enableAccessibleFieldDOMStructure: false,
                    },
                }}
                localeText={{
                    datePickerToolbarTitle: t(I18N_NAMESPACE, "datePicker.datePickerToolbarTitle"),
                    cancelButtonLabel: t(I18N_NAMESPACE, "datePicker.cancelButtonLabel"),
                    okButtonLabel: t(I18N_NAMESPACE, "datePicker.okButtonLabel"),
                }}
                clearIcon={props.clearIcon}
            />
        </LocalizationProvider>
    )
}

DatePicker.propTypes = {
    ...MuiDatePicker.propTypes,
}

DatePicker.defaultProps = MuiDatePicker.defaultProps